module.exports = __webpack_public_path__ + "Roboto-RegularItalic.8add1ba317c27e39b778.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-RegularItalic.woff
// module chunks = 16